import { AppSource } from '@application/config';
import { IRolePermission } from './role.interface';
import { PasswordDefinitionMode } from './user-profile.interface';

export interface IUser {
  PersonId?: string;
  Email: string;
  FirstName: string;
  RoleId: string;
  IsActive: boolean;
  IsOwner: boolean;
  TenantId?: string;
  AbstractedTenantName?: string;
  Permissions?: IRolePermission[];
  backgroundColor?: string; //frontend only;
  AppSource?: AppSource;
  PasswordDefinitionMode?: PasswordDefinitionMode;
  TemporaryPassword?: string | null;
}

export type TLoginCode = {
  AddedBy: string;
  AddedOn: string; 
  ExpiresIn: string;
  IsValid: boolean;
  LoginCodeId: string;
  PersonId: string;
  Sid: string;
  TenantId: string;
  Type: number;
};

export enum EUserServiceErrorCode {
  LoginCodeDeniedInSupportSession = 'LoginCodeDeniedInSupportSession',
  NetworkPermissionForbidden = 'NetworkPermissionForbidden',
  NetworkPermissionRequired = 'NetworkPermissionRequired',
  NetworkSupportSessionReadOnly = 'NetworkSupportSessionReadOnly',
  NetworkWithoutHeadquarter = 'NetworkWithoutHeadquarter',
  NetworkDirectoryUnavailable = 'NetworkDirectoryUnavailable',
  NetworkSelfAssignmentForbidden = 'NetworkSelfAssignmentForbidden',
  NetworkPermissionConcurrentUpdate = 'NetworkPermissionConcurrentUpdate',
  NetworkManagementOnlyForHeadquarter = 'NetworkManagementOnlyForHeadquarter',
  NetworkManagementRequiresHeadquarterOwner = 'NetworkManagementRequiresHeadquarterOwner',
}

export const NETWORK_ROLE_SAVE_ERROR_MESSAGES: Readonly<Partial<Record<EUserServiceErrorCode, string>>> = {
  [EUserServiceErrorCode.NetworkPermissionRequired]: 'SETTINGS.USERS.NETWORK_PERMISSIONS_REJECTED.MISSING_PERMISSION',
  [EUserServiceErrorCode.NetworkPermissionForbidden]: 'SETTINGS.USERS.NETWORK_PERMISSIONS_REJECTED.HEADQUARTER_ONLY',
  [EUserServiceErrorCode.NetworkSupportSessionReadOnly]: 'SETTINGS.USERS.NETWORK_PERMISSIONS_REJECTED.SUPPORT_SESSION',
  [EUserServiceErrorCode.NetworkSelfAssignmentForbidden]: 'SETTINGS.USERS.NETWORK_PERMISSIONS_REJECTED.OWN_ROLE',
  [EUserServiceErrorCode.NetworkManagementRequiresHeadquarterOwner]:
    'SETTINGS.USERS.NETWORK_PERMISSIONS_REJECTED.MANAGEMENT_OWNER_ONLY',
  [EUserServiceErrorCode.NetworkManagementOnlyForHeadquarter]:
    'SETTINGS.USERS.NETWORK_PERMISSIONS_REJECTED.MANAGEMENT_ONLY_HEADQUARTER',
  [EUserServiceErrorCode.NetworkPermissionConcurrentUpdate]: 'SETTINGS.USERS.NETWORK_PERMISSIONS_REJECTED.CONCURRENT_UPDATE',
  [EUserServiceErrorCode.NetworkWithoutHeadquarter]: 'SETTINGS.USERS.NETWORK_PERMISSIONS_REJECTED.WITHOUT_HEADQUARTER',
  [EUserServiceErrorCode.NetworkDirectoryUnavailable]: 'SETTINGS.USERS.NETWORK_PERMISSIONS_REJECTED.UNAVAILABLE',
};